import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /auftraege. List lives in auftraege.index.tsx,
 * detail in auftraege.$id.tsx, new-form in auftraege.neu.tsx.
 */
export const Route = createFileRoute('/auftraege')({
  component: AuftraegeLayout,
});

function AuftraegeLayout(): JSX.Element {
  return <Outlet />;
}
